import React from 'react';
import { DataTable } from '@frontend/app/refresh-components/DataTableV2';
import { TMember } from '../../../MembersWizard/types';
import { CustomColumn } from '../../RefreshManageOffer';

interface IProps {
    data: TMember[];
    refreshColumn: CustomColumn[];
}

const RefreshPromoCodes: React.FC<IProps> = ({ data, refreshColumn }) => {
    return (
      <div className="flex flex-col gap-4">
        <p className="text-sm font-medium text-grey-6">Refresh Promo Codes</p>
        <p className="text-xs font-medium text-grey-6 m-0">{data.length} {' '}{data.length === 1 ? 'Member' : 'Members'}{' '}Selected</p>
        <DataTable
          columns={refreshColumn}
          data={data}
        />
      </div>
    );
};

export default RefreshPromoCodes;
